import { DefaultTheme } from 'styled-components';

const defaultTheme: DefaultTheme = {
  borderRadius: '5px',

  colors: {
    primary: '#ffffff',
    secondary: '#3ECFFE',
  },
};

export default defaultTheme;
